<section class="admin-section">
  <h1>{{ 'ADMIN.INTEGRATIONS.TITLE' | translate }}</h1>

  <input nz-input [(ngModel)]="search" [placeholder]="'ADMIN.SEATS_RBAC.SEARCH' | translate" />

  <nz-table #companiesTable [nzData]="filteredCompanies" [nzLoading]="loading" [nzPageSize]="10">
    <thead>
    <tr>
      <th>{{ 'ADMIN.SEATS_RBAC.COMPANY' | translate }}</th>
      <th>{{ 'ADMIN.INTEGRATIONS.USED_ALLOWED' | translate }}</th>
      <th>{{ 'ADMIN.INTEGRATIONS.CONNECTED_PROVIDERS' | translate }}</th>
      <th>{{ 'ADMIN.INTEGRATIONS.LIMIT' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let company of companiesTable.data">
      <td>{{ company.name }}<br /><small>{{ company.domain }}</small></td>
      <td>{{ company.integrationsUsed || 0 }} / {{ company.integrationsAllowedEffective || 0 }}</td>
      <td>
        <ng-container *ngIf="company.connectedProviders?.length; else noProviders">
          <ng-container *ngFor="let provider of company.connectedProviders">
            <nz-tag>{{ provider }}</nz-tag>
          </ng-container>
        </ng-container>
        <ng-template #noProviders>{{ 'ADMIN.INTEGRATIONS.NONE' | translate }}</ng-template>
      </td>
      <td><input nz-input type="number" min="0" [(ngModel)]="company.integrationLimit" /></td>
      <td><button nz-button nzType="primary" (click)="saveCompany(company)">{{ 'ADMIN.SEATS_RBAC.SAVE' | translate }}</button></td>
    </tr>
    </tbody>
  </nz-table>
</section>

<section *ngIf="sftpSetupAvailable" class="admin-section provider-configuration">
  <h2>{{ 'ADMIN.INTEGRATIONS.PROVIDER_CONFIGURATION' | translate }}</h2>
  <nz-card>
    <h3>{{ 'ADMIN.INTEGRATIONS.SFTP_TITLE' | translate }}</h3>
    <p *ngIf="sftpEndpointMeta">{{ sftpEndpointMeta.environment }} · {{ sftpEndpointMeta.bucket }} · {{ sftpEndpointMeta.rootPrefix }}</p>
    <div *ngIf="sftpEndpoint" class="sftp-form">
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_HOST' | translate }}</label>
      <input nz-input [(ngModel)]="sftpEndpoint.hostname" (ngModelChange)="endpointErrors.hostname = ''" />
      <small class="field-error" *ngIf="endpointErrors.hostname">{{ endpointErrors.hostname }}</small>
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_PORT' | translate }}</label>
      <input nz-input type="number" [(ngModel)]="sftpEndpoint.port" (ngModelChange)="endpointErrors.port = ''" />
      <small class="field-error" *ngIf="endpointErrors.port">{{ endpointErrors.port }}</small>
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_FINGERPRINT' | translate }}</label>
      <input nz-input [(ngModel)]="sftpEndpoint.hostKeyFingerprint" (ngModelChange)="endpointErrors.hostKeyFingerprint = ''" />
      <small class="field-error" *ngIf="endpointErrors.hostKeyFingerprint">{{ endpointErrors.hostKeyFingerprint }}</small>
      <label class="checkbox-label"><input type="checkbox" [(ngModel)]="sftpEndpoint.provisioningEnabled" /> {{ 'ADMIN.INTEGRATIONS.SFTP_PROVISIONING_ENABLED' | translate }}</label>
      <small>{{ 'ADMIN.INTEGRATIONS.SFTP_PROVISIONING_ENABLED_HELP' | translate }}</small>
      <button nz-button nzType="primary" (click)="saveSftpEndpoint()">{{ 'ADMIN.SEATS_RBAC.SAVE' | translate }}</button>
    </div>
  </nz-card>
</section>

<section *ngIf="sftpSetupAvailable" class="admin-section provisioning-operations">
  <h2>{{ 'ADMIN.INTEGRATIONS.PROVISIONING_OPERATIONS' | translate }}</h2>
  <nz-card>
  <h3>{{ 'ADMIN.INTEGRATIONS.SFTP_QUEUE' | translate }}</h3>
  <nz-table [nzData]="sftpRequests" [nzPageSize]="10">
    <thead><tr><th>{{ 'ADMIN.SEATS_RBAC.COMPANY' | translate }}</th><th>{{ 'ADMIN.INTEGRATIONS.SFTP_STATUS' | translate }}</th><th>{{ 'ADMIN.INTEGRATIONS.SFTP_KEY_FINGERPRINT' | translate }}</th><th>{{ 'ADMIN.SEATS_RBAC.ACTIONS' | translate }}</th></tr></thead>
    <tbody>
      <tr *ngFor="let request of sftpRequests">
        <td>{{ request.company?.name || '-' }}</td><td>{{ lifecycleLabel(request.lifecycleStatus) }}</td><td>{{ request.sshKeyFingerprint || '-' }}</td>
        <td>
          <button nz-button (click)="selectSftpRequest(request)">{{ (canProvision(request) ? 'INTEGRATION.STATUS.SETUP' : 'ADMIN.INTEGRATIONS.SFTP_DETAILS') | translate }}</button>
          <button *ngIf="request.lifecycleStatus === 'awaiting_first_file' || request.lifecycleStatus === 'active'" nz-button (click)="changeSftpState(request, 'pause')">{{ 'INTEGRATION.SFTP.PAUSE' | translate }}</button>
          <button *ngIf="request.lifecycleStatus === 'paused'" nz-button (click)="changeSftpState(request, 'resume')">{{ 'INTEGRATION.SFTP.RESUME' | translate }}</button>
          <button *ngIf="request.lifecycleStatus !== 'disconnected'" nz-button nzDanger (click)="changeSftpState(request, 'disconnect')">{{ 'INTEGRATION.STATUS.DISCONNECT' | translate }}</button>
          <button *ngIf="request.lifecycleStatus !== 'disconnected' && request.lifecycleStatus !== 'error'" nz-button (click)="changeSftpState(request, 'error')">{{ 'ADMIN.INTEGRATIONS.SFTP_MARK_ERROR' | translate }}</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div *ngIf="selectedSftpRequest" class="mt-16">
    <h3>{{ selectedSftpRequest.company?.name || '-' }}</h3>
    <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_CONNECTION_ID' | translate }}:</b> {{ selectedSftpRequest.id }}</p>
    <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_PUBLIC_KEY' | translate }}:</b> {{ selectedSftpRequest.sshPublicKey }}</p>
    <div *ngIf="canProvision(selectedSftpRequest); else sftpDetails" class="sftp-form">
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_USERNAME' | translate }}</label>
      <input nz-input [(ngModel)]="readiness.sftpUsername" (ngModelChange)="readinessErrors.sftpUsername = ''" />
      <small class="field-error" *ngIf="readinessErrors.sftpUsername">{{ readinessErrors.sftpUsername }}</small>
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_UPLOAD_DIRECTORY' | translate }}</label>
      <input nz-input [(ngModel)]="readiness.uploadDirectory" (ngModelChange)="readinessErrors.uploadDirectory = ''" />
      <small class="field-error" *ngIf="readinessErrors.uploadDirectory">{{ readinessErrors.uploadDirectory }}</small>
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_PREFIX' | translate }}</label>
      <input nz-input [ngModel]="readiness.s3Prefix" [readonly]="true" />
      <label>{{ 'ADMIN.INTEGRATIONS.SFTP_FORMAT' | translate }}</label>
      <select [(ngModel)]="readiness.acceptedFileExtension" (ngModelChange)="readinessErrors.acceptedFileExtension = ''">
        <option value="xlsx">{{ 'ADMIN.INTEGRATIONS.SFTP_FORMAT_XLSX' | translate }}</option>
        <option value="xls">{{ 'ADMIN.INTEGRATIONS.SFTP_FORMAT_XLS' | translate }}</option>
      </select>
      <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_REQUIRED_FILENAME' | translate }}:</b> haussoft.{{ readiness.acceptedFileExtension }}</p>
      <small class="field-error" *ngIf="readinessErrors.acceptedFileExtension">{{ readinessErrors.acceptedFileExtension }}</small>
      <label class="checkbox-label"><input type="checkbox" [(ngModel)]="readiness.sftpGoProvisioningConfirmed" (ngModelChange)="readinessErrors.sftpGoProvisioningConfirmed = ''" /> {{ 'ADMIN.INTEGRATIONS.SFTP_CONFIRM' | translate }}</label>
      <small class="field-error" *ngIf="readinessErrors.sftpGoProvisioningConfirmed">{{ readinessErrors.sftpGoProvisioningConfirmed }}</small>
      <button nz-button nzType="primary" (click)="markSftpReady()">{{ 'ADMIN.INTEGRATIONS.SFTP_MARK_READY' | translate }}</button>
    </div>
    <ng-template #sftpDetails>
      <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_STATUS' | translate }}:</b> {{ lifecycleLabel(selectedSftpRequest.lifecycleStatus) }}</p>
      <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_USERNAME' | translate }}:</b> {{ selectedSftpRequest.endpoint?.username || '-' }}</p>
      <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_UPLOAD_DIRECTORY' | translate }}:</b> {{ selectedSftpRequest.endpoint?.uploadDirectory || '-' }}</p>
      <p><b>{{ 'ADMIN.INTEGRATIONS.SFTP_REQUIRED_FILENAME' | translate }}:</b> {{ selectedSftpRequest.acceptedFileName || '-' }}</p>
    </ng-template>
  </div>
  </nz-card>
</section>

